import React, { Component } from "react";
import Row from "../../containers/row";
import FlexText from "../../flexText";
import ThreeCol from "../../containers/threeCol";
import CircleHead from "../../circleHead";
import Gutters from "../../config/gutters";
import gutter from "../../config/vars";
import TitleBar from "../../titleBar";
const diameter = window.innerWidth > 899 ? "227px" : "300px";

class CircleRow extends Component {
  returnCircles() {
    const circleStyles = {
      paddingBottom: "32px",
      lineBreak: "word",
      display: "inline-flex",
      textDecoration: "none",
      width: "300px",
      textAlign: "center",
      paddingRight: "24px"
    };
    return this.props.rowData.map((circle, index) =>
      <ThreeCol className="circlesRow" key={index} styles={{ ...circleStyles }}>
        <a
          id={"item" + this.props.item + "_image" + index}
          className={this.props.blockStyle.attributes.field_link_colors.name}
          tabIndex="0"
          href={circle.field_link_1.url}
          style={{ textDecoration: "none", borderBottom: "0px" }}
        >
          <CircleHead
            image={circle.field_image.uri}
            size={diameter}
            nudgeX={circle.field_integer_1 + "%"}
            nudgeY={circle.field_integer_2 + "%"}
            styles={{
              margin: "auto"
            }}
          />
          {typeof circle.field_link_1 !== "undefined"
            ? <FlexText
                class="hover"
                tag="div"
                max="32"
                min="17"
                styles={{
                  textAlign: "center",
                  fontWeight: "bold",
                  margin: window.innerWidth < 900 ? "16px 0 4px" : "20px 0 4px",

                  textTransform: "uppercase",
                  fontFamily: "Oswald"
                }}
              >
                {"<span>" + circle.field_link_1.title + "</span>"}
              </FlexText>
            : null}
          {typeof circle.field_link_1 !== "undefined"
            ? <FlexText
                class="hover"
                tag="div"
                max="17"
                min="14"
                styles={{
                  textAlign: "center",
                  fontFamily: "Roboto",
                  textTransform: "none",

                  marginBottom: window.innerWidth < 900 ? "24px" : "0"
                }}
              >
                {"<span>" + circle.field_text_1 + "</span>"}
              </FlexText>
            : null}
        </a>
      </ThreeCol>
    );
  }

  render() {
    const margin =
      Gutters.spacings[this.props.blockStyle.top] +
      "px 0px " +
      Gutters.spacings[this.props.blockStyle.btm] +
      "px 0px";
    const padding =
      Gutters.spacings[this.props.blockStyle.inner_top] +
      "px " +
      gutter +
      " " +
      Gutters.spacings[this.props.blockStyle.inner_btm] +
      "px " +
      gutter;
    const titleStyles = this.props.blockStyle.attributes
      .field_title_color_font[0];
    const titleClassName = this.props.blockStyle.name.replace(" ", "-");
    return (
      <Row
        minHeight="588px"
        padding={padding}
        margin={margin}
        styles={{ textAlign: "center" }}
      >
        {this.props.showTitle !== "0"
          ? <TitleBar
              className={titleClassName}
              color={titleStyles.field_color_1}
              bgc={titleStyles.field_bgcolor_1}
              fontFamily={titleStyles.field_font_1.name}
              max="19"
              min="16"
              container="Left"
              tag="h2"
            >
              {this.props.title}
            </TitleBar>
          : null}
        {this.returnCircles()}
      </Row>
    );
  }
}

export default CircleRow;
